<div class="flex flex-wrap gap-10 justify-center"
     [class.z-10]="isMultiSelectMode"
     [class.relative]="isMultiSelectMode">
  @if (!media || media.length === 0) {
    <div class="text-gray-500 italic p-5">
      {{ 'animalMedia.noMedia' | transloco }}
    </div>
  }
  @for (item of media; track item.id) {
    <div
      class="w-[15.5rem] h-96 perspective-[1000px] relative rounded-sm border-2"
      (click)="toggleSelect.emit(item.id)"
      tabindex="0"
      role="button"
      [ngClass]="{
        'border-(--p-primary-color)': isSelected(item.id),
        'border-transparent': !isSelected(item.id),
        'cursor-pointer': isMultiSelectMode
      }"
    >
      <div class="relative w-full h-full [transform-style:preserve-3d] transition-transform duration-700"
           [class.rotate-y-180]="flippedItems[item.id]">
        <div class="absolute inset-0 rounded-lg bg-white p-4 shadow z-2 backface-hidden">
          <!-- Flip-Lasche (dreht mit der Karte mit) -->
          <div class="absolute top-1/2 -translate-y-1/2 right-[-1.75rem] w-8 h-14 backface-hidden">
            <p-button
              styleClass="w-full h-full bg-white rounded shadow flex items-center justify-center text-xl text-primary"
              (click)="toggleFlip.emit({id: item.id, event: $event})"
              [class.cursor-default]="isMultiSelectMode"
              [attr.aria-label]="'animalMedia.aria.goToBack' | transloco"
              icon="pi pi-chevron-right"
              variant="text"
            />
          </div>

          <!-- Button für Maximieren -->
          <div class="absolute top-2 right-2 z-10 backface-hidden">
            <p-button
              icon="pi pi-window-maximize"
              styleClass="p-button-rounded p-button-text bg-white/80"
              (click)="openMediaDialog(item, $event)"
              [attr.aria-label]="'animalMedia.aria.maximizeMedia' | transloco"
            ></p-button>
          </div>

          <div class="text-sm text-gray-500 text-center mb-[10px]">{{ 'animalMedia.labels.category' | transloco }}</div>
          <div class="text-green-700 text-center font-bold mb-2 h-[46px]">
            {{ item.translatedCategories || '-' }}
          </div>
          <div class="relative w-full h-[180px]">
            @if (item.type === 'video' && item.id) {
              <app-animal-video-container
                [animal]="animal"
                [id]="item.id"
              />
            } @else if (item.type === 'image' && item.id) {
              <app-animal-image-container
                [animal]="animal"
                [id]="item.id"
                [variant]="'app-preview'"
              />
            }
          </div>
          <div class="mt-[5px] px-2 flex items-center gap-2">
            <p-datepicker
              [(ngModel)]="item.uiDate"
              [showIcon]="true"
              iconDisplay="input"
              [showOnFocus]="false"
              dateFormat="dd.mm.yy"
              styleClass="media-date-picker"
              appendTo="body"
              (onSelect)="dateChange.emit(item)"
            ></p-datepicker>
            <span class="text-xs text-gray-400 whitespace-nowrap">
              {{ (item.fileSize / 1048576) | number:'1.2-2' }} MB
            </span>
          </div>
          <div class="flex justify-around mt-4">
            <i
              (click)="toggleWebsite.emit(item)"
              tabindex="1"
              role="button"
              [ngClass]="item.syncWithWebsite ? 'bg-[#8db43f]' : 'bg-gray-200'"
              class="pi pi-desktop text-white rounded-full p-2 text-xl"
              [attr.aria-label]="'animalMedia.aria.toggleWebsiteSync' | transloco"
              [pTooltip]="'animalMedia.aria.toggleWebsiteSync' | transloco" tooltipPosition="top"
            ></i>
            <i
              (click)="toggleSharedFolder.emit(item)"
              tabindex="0"
              role="button"
              [ngClass]="item.syncWithSharedFolder ? 'bg-[#8db43f]' : 'bg-gray-200'"
              class="pi pi-file-export text-white rounded-full p-2 text-xl"
              [attr.aria-label]="'animalMedia.aria.toggleSharepointSync' | transloco"
              [pTooltip]="'animalMedia.aria.toggleSharepointSync' | transloco" tooltipPosition="top"
            ></i>
            @if (item.type === 'image') {
              <i
                (click)="togglePreview.emit(item)"
                tabindex="2"
                role="button"
                [ngClass]="item.preview ? 'bg-[#8db43f]' : 'bg-gray-200'"
                class="pi pi-image text-white rounded-full p-2 text-xl"
                [attr.aria-label]="'animalMedia.aria.previewMedia' | transloco"
                [pTooltip]="'animalMedia.aria.previewMedia' | transloco" tooltipPosition="top"
              ></i>
            }
          </div>
        </div>

        <div class="absolute inset-0 rounded-lg bg-white p-4 shadow [transform:rotateY(180deg)] backface-hidden">
          <!-- Flip-Lasche (dreht mit der Karte mit) -->
          <div class="absolute top-1/2 -translate-y-1/2 right-[-1.75rem] w-8 h-14 backface-hidden">
            <p-button
              styleClass="w-full h-full bg-white rounded shadow flex items-center justify-center text-xl text-primary"
              (click)="toggleFlip.emit({id: item.id, event: $event})"
              [class.cursor-default]="isMultiSelectMode"
              [attr.aria-label]="'animalMedia.aria.goToFront' | transloco"
              icon="pi pi-chevron-left"
              variant="text"
            />
          </div>

          <div class="text-sm text-gray-500 mb-2">{{ 'animalMedia.labels.categories' | transloco }}</div>
          <div class="flex flex-wrap gap-2">
            <p-multiSelect
              [options]="mediaCategoryOptions"
              [(ngModel)]="item.categories"
              [placeholder]="'animalMedia.item.categories.placeholder' | transloco"
              optionLabel="name"
              optionValue="value"
              [showToggleAll]="false"
              [filter]="false"
              display="chip"
              class="w-full"
              (onChange)="categoryChange.emit(item)"
              [dropdownIcon]="'pi pi-chevron-down'"
            >
              <ng-template pTemplate="item" let-cat>
                {{ cat.name }}
              </ng-template>
            </p-multiSelect>
          </div>
          <div class="flex flex-col mt-4 gap-1 items-stretch">
            <p-button
              [label]="'animalMedia.item.btnDescription' | transloco"
              icon="pi pi-info-circle"
              styleClass="w-full"
              (click)="openDescriptionDialog(item, 'description')"
            />
            <p-button
              [label]="'animalMedia.item.btnWebsiteDescription' | transloco"
              icon="pi pi-globe"
              styleClass="w-full"
              (click)="openDescriptionDialog(item, 'externalDescription')"
            />
            <p-button
              [label]="'animalMedia.item.btnDownload' | transloco"
              icon="pi pi-download"
              styleClass="w-full"
              (click)="downloadMedia.emit(item)"
            />
            <p-button
              [label]="'animalMedia.item.btnDelete' | transloco"
              icon="pi pi-globe"
              severity="danger"
              (click)="deleteMedia.emit(item)"
              styleClass="w-full"
            />
          </div>
        </div>
      </div>
    </div>
  }
</div>

<!-- Dialog für großes Media-Preview -->
<p-dialog
  [(visible)]="mediaDialogVisible"
  [modal]="true"
  [closable]="true"
  [maximizable]="true"
  [blockScroll]="true"
  [dismissableMask]="true"
  [style]="{width: '80vw', height: '80vh'}"
  (onHide)="closeMediaDialog()"
>
  <ng-template pTemplate="header">
    <span>{{ selectedMedia?.translatedCategories || '-' }}</span>
  </ng-template>

  <div class="relative h-full">
    @if (selectedMedia?.type === 'image' && selectedMedia?.id) {
      <app-animal-image-container
        [id]="selectedMedia?.id"
        [variant]="'full'"
        [preview]="false"
        class="max-h-[70vh] max-w-full"
      />
    } @else if (selectedMedia?.type === 'video' && selectedMedia?.id) {
      <app-animal-video-container
        [animal]="animal"
        [id]="selectedMedia?.id"
        class="max-h-[70vh] max-w-full"
      />
    }
  </div>
</p-dialog>

<p-dialog
  [(visible)]="dialogVisible"
  [modal]="true"
  [closable]="false"
  [blockScroll]="true"
  [dismissableMask]="false"
  [style]="{width: '70vw', height: '70vh'}"
  (onHide)="closeDialog()"
>
  <ng-template pTemplate="header">
    <span *ngIf="dialogType === 'description'">
      {{ 'animalMedia.dialog.editDescription' | transloco }}
    </span>
    <span *ngIf="dialogType === 'externalDescription'">
      {{ 'animalMedia.dialog.editExternalDescription' | transloco }}
    </span>
  </ng-template>
  <div>
    <p-editor
      [(ngModel)]="dialogValue"
      class="w-full"
      [style]="{ height: '350px' }"
      [placeholder]="'animalMedia.dialog.descriptionPlaceholder' | transloco"
    />
  </div>
  <ng-template pTemplate="footer">
    <div class="flex gap-2">
      <p-button
        (click)="closeDialog()"
        [label]="'modal.cancel' | transloco"
        [text]="true"
        icon="pi pi-times"
      />
      <p-button
        (click)="saveDescription()"
        [label]="'confirmDialog.acceptLabel.save' | transloco"
        [disabled]="!dialogValue"
        icon="pi pi-save"
      />
    </div>
  </ng-template>
</p-dialog>
